import React, { useState, useEffect } from 'react';
import axios from 'axios';
import configApp from '../../config/apiConfig';

const ConfiguracionParametros = () => {
    const [diccionario, setDiccionario] = useState([]);
    const [valores, setValores] = useState({});
    const [cargando, setCargando] = useState(true);
    const [debugRaw, setDebugRaw] = useState(""); // 🚩 Para ver qué llega exactamente

    const token = localStorage.getItem('token');
    const API_BASE = configApp.api_url;

    useEffect(() => {
        cargarDatos();
    }, []);

    const cargarDatos = async () => {
        try {
            setCargando(true);
            const [resDict, resVal] = await Promise.all([
                axios.get(`${API_BASE}/api/configuracion/diccionario`, { headers: { token } }),
                axios.get(`${API_BASE}/api/configuracion/parametros/valores`, { headers: { token } })
            ]);

            if (resDict.data.completado) {
                const dict = resDict.data.parametros;
                
                let vals = resVal.data.ajustes; 
                setDebugRaw(JSON.stringify(vals)); // Guardamos para ver en pantalla

                if (typeof vals === 'string') {
                    try {
                        vals = JSON.parse(vals);
                        if (typeof vals === 'string') vals = JSON.parse(vals);
                    } catch (e) {
                        vals = {}; 
                    }
                }

                if (!vals || typeof vals !== 'object') vals = {};

                const valoresIniciales = {};
                
                dict.forEach(function (p) {
                    // 🚩 AQUÍ ESTÁ LA CLAVE: Borramos espacios en blanco invisibles de la BD
                    const cod = String(p.codigo || '').trim(); 
                    const valorBD = vals[cod]; 

                    if (valorBD !== undefined && valorBD !== null) {
                        valoresIniciales[cod] = valorBD;
                    } else {
                        if (p.tipo_dato === 'BOOLEAN') {
                            valoresIniciales[cod] = (p.valor_defecto === '1' || p.valor_defecto === 'true');
                        } else if (p.tipo_dato === 'NUMBER') {
                            valoresIniciales[cod] = Number(p.valor_defecto || 0);
                        } else {
                            valoresIniciales[cod] = p.valor_defecto || '';
                        }
                    }
                });

                // 🚩 FALLBACK: PROPINA_MESAS - Propina al cobrar mesas
                const existePropinaMesas = dict.some(p => String(p.codigo || '').trim() === 'PROPINA_MESAS');
                if (!existePropinaMesas) {
                    dict.push({
                        id: 'PROPINA_MESAS',
                        codigo: 'PROPINA_MESAS',
                        nombre: 'Propina en Mesas',
                        descripcion: 'Sugiere agregar propina al cobrar una cuenta de mesa',
                        tipo_dato: 'BOOLEAN',
                        categoria: 'VENTAS',
                        valor_defecto: '0',
                        activo: 1,
                        orden_visual: 68
                    });
                    if (valoresIniciales['PROPINA_MESAS'] === undefined) {
                        valoresIniciales['PROPINA_MESAS'] = false;
                    }
                }

                // 🚩 FALLBACK: PROPINA_TPV - Propina en ventas de TPV
                const existePropinaTpv = dict.some(p => String(p.codigo || '').trim() === 'PROPINA_TPV');
                if (!existePropinaTpv) {
                    dict.push({
                        id: 'PROPINA_TPV',
                        codigo: 'PROPINA_TPV',
                        nombre: 'Propina en TPV',
                        descripcion: 'Sugiere agregar propina al cobrar ventas de mostrador, delivery o retiro',
                        tipo_dato: 'BOOLEAN',
                        categoria: 'VENTAS',
                        valor_defecto: '0',
                        activo: 1,
                        orden_visual: 69
                    });
                    if (valoresIniciales['PROPINA_TPV'] === undefined) {
                        valoresIniciales['PROPINA_TPV'] = false;
                    }
                }

                // 🚩 FALLBACK: IMPRIMIR_RECIBO - Controla impresión de comprobante/ticket
                const existeImprimirRecibo = dict.some(p => String(p.codigo || '').trim() === 'IMPRIMIR_RECIBO');
                if (!existeImprimirRecibo) {
                    dict.push({
                        id: 'IMPRIMIR_RECIBO',
                        codigo: 'IMPRIMIR_RECIBO',
                        nombre: 'Imprimir Recibo',
                        descripcion: 'Controla si se imprime el comprobante/ticket de venta al confirmar un pago',
                        tipo_dato: 'BOOLEAN',
                        categoria: 'TICKET',
                        valor_defecto: '1',
                        activo: 1,
                        orden_visual: 71
                    });
                    if (valoresIniciales['IMPRIMIR_RECIBO'] === undefined) {
                        valoresIniciales['IMPRIMIR_RECIBO'] = true;
                    }
                }

                // 🚩 FALLBACK: PORCENTAJE_PROPINA - Porcentaje de propina
                const existePorcPropina = dict.some(p => String(p.codigo || '').trim() === 'PORCENTAJE_PROPINA');
                if (!existePorcPropina) {
                    dict.push({
                        id: 'PORCENTAJE_PROPINA',
                        codigo: 'PORCENTAJE_PROPINA',
                        nombre: 'Porcentaje Propina',
                        descripcion: 'Porcentaje de propina a sugerir (ej: 10 para 10%)',
                        tipo_dato: 'NUMBER',
                        categoria: 'VENTAS',
                        valor_defecto: '10',
                        activo: 1,
                        orden_visual: 70
                    });
                    if (valoresIniciales['PORCENTAJE_PROPINA'] === undefined) {
                        valoresIniciales['PORCENTAJE_PROPINA'] = 10;
                    }
                }

                // 🚩 FALLBACK: Agregamos VARIANTES_LAYOUT_HORIZONTAL si no viene del backend
                const existeFlag = dict.some(p => String(p.codigo || '').trim() === 'VARIANTES_LAYOUT_HORIZONTAL');
                if (!existeFlag) {
                    dict.push({
                        id: 'VARIANTES_LAYOUT_HORIZONTAL',
                        codigo: 'VARIANTES_LAYOUT_HORIZONTAL',
                        nombre: 'Layout horizontal de variantes',
                        descripcion: 'Muestra las variantes de producto en fila (horizontal) en lugar de columna (vertical) en el TPV',
                        tipo_dato: 'BOOLEAN',
                        categoria: 'VENTAS',
                        valor_defecto: '0',
                        activo: 1,
                        orden_visual: 50
                    });
                    if (valoresIniciales['VARIANTES_LAYOUT_HORIZONTAL'] === undefined) {
                        valoresIniciales['VARIANTES_LAYOUT_HORIZONTAL'] = false;
                    }
                }
                // 🚩 DEBUG: Mostrar qué códigos vienen del backend
                console.log('📋 CÓDIGOS RECIBIDOS DEL BACKEND:', dict.map(p => ({codigo: p.codigo, nombre: p.nombre})));

                // 🚩 FILTRO: Solo permitir flags que están en la whitelist (excluye flags viejos)
                //
                // serv_imp e imp_80 se agregaron el 2026-08-20: la whitelist los
                // dejaba afuera desde junio, y son los dos que lee de verdad
                // services/Impresion.js para decidir si la comanda sale por el
                // servicio local o por window.print(), y con que ancho de papel.
                // Al no aparecer en esta pantalla, habilitar el servicio de
                // impresion en un negocio nuevo obligaba a meter mano a la BD
                // (INSERT en vtgx_config_negocio). Los negocios viejos no lo
                // notaban porque su valor ya estaba guardado de antes.
                //
                // NO se agregan imp_comanda ni imp_recibo: esos si son flags
                // viejos, reemplazados por IMPRIMIR_RECIBO, que ya esta en la
                // lista. Ningun componente los lee.
                // CERRAR_DELIVERY_PAGADO se agrego el 2026-08-24: lo lee TPV.js para
                // decidir si un delivery ya pagado se cierra al tiro en vez de quedar
                // esperando en el panel de pedidos activos. Sin estar en esta lista, la
                // fila existe en vtgx_config_parametros_def pero el switch no se ve.
                const whitelist = ['VARIANTES_LAYOUT_HORIZONTAL', 'USA_DESCUENTOS', 'PAGO_EN_MESA', 'DIVIDIR_CUENTA', 'PROPINA_MESAS', 'PROPINA_TPV', 'PORCENTAJE_PROPINA', 'IMPRIMIR_RECIBO', 'serv_imp', 'imp_80', 'CERRAR_DELIVERY_PAGADO'];
                const diccionarioFiltrado = dict.filter(p => {
                    const cod = String(p.codigo || '').trim();
                    return whitelist.includes(cod);
                });
                setDiccionario(diccionarioFiltrado);
                setValores(valoresIniciales);
            }
            setCargando(false);
        } catch (e) {
            console.error("Error cargando datos:", e);
            setCargando(false);
        }
    };

    // 🚩 AUTO-SAVE: Ref para el timer y para los valores (evita closures viejos)
    const autoSaveTimer = React.useRef(null);
    const valoresGuardarRef = React.useRef({});
    
    // Sincronizar la ref cada vez que cambien los valores
    useEffect(() => {
        valoresGuardarRef.current = valores;
    }, [valores]);

    const handleInputChange = (codigo, valor, tipo) => {
        const codLimpiado = String(codigo).trim();
        const nuevoValor = tipo === 'NUMBER' ? Number(valor) : valor;
        
        // 1. Actualizamos el estado local al tiro (para que la UI responda)
        setValores(prev => {
            const nuevos = { ...prev, [codLimpiado]: nuevoValor };
            // También actualizamos la ref para el auto-save
            valoresGuardarRef.current = nuevos;
            return nuevos;
        });
        
        // 2. AUTO-SAVE con debounce: cancelamos el timer anterior
        if (autoSaveTimer.current) clearTimeout(autoSaveTimer.current);
        autoSaveTimer.current = setTimeout(() => {
            // Usamos la ref para tener los valores más actualizados
            const dataToSave = valoresGuardarRef.current;
            axios.post(`${API_BASE}/api/configuracion/guardar`, dataToSave, { headers: { token } })
                .then(() => console.log(`✅ Auto-save OK`))
                .catch(err => console.error("❌ Error auto-save:", err));
        }, 400);
    };

    const guardarTodo = async () => {
        try {
            await axios.post(`${API_BASE}/api/configuracion/guardar`, valores, { headers: { token } });
            alert('✅ ¡Cambios guardados!');
            cargarDatos(); // 🚩 Recargamos automáticamente para validar
        } catch (error) {
            alert('❌ Error al guardar.');
        }
    };

    if (cargando) return <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>;

  return (
    <div className="bg-light min-vh-100 py-5">
        <div className="container" style={{ maxWidth: '1000px' }}>
            
            {/* Cabecera Estilo Glassmorphism */}
            <div className="d-flex justify-content-between align-items-center mb-5 bg-white p-4 rounded-lg shadow-sm border" style={{ position: 'sticky', top: '10px', zIndex: 1020 }}>
                <div>
                    <h1 className="h3 font-weight-bold text-dark mb-0">⚙️ Ajustes del Sistema</h1>
                    <p className="text-muted mb-0">Gestiona la configuración de impresión y ventas de tu negocio</p>
                </div>
                <button className="btn btn-primary btn-lg rounded-pill shadow px-5 font-weight-bold" onClick={guardarTodo}>
                    <i className="fas fa-save mr-2"></i> Guardar Cambios
                </button>
            </div>

            {['GENERAL', 'VENTAS', 'TICKET', 'SISTEMA'].map(cat => {
                const paramsDeEstaCat = diccionario.filter(p => (p.categoria || '').toUpperCase() === cat);
                
                // Si la categoría está vacía, no la mostramos para no ensuciar
                if (paramsDeEstaCat.length === 0) return null;

                return (
                    <div key={cat} className="mb-5">
                        <h5 className="text-muted font-weight-bold mb-3 ml-2" style={{ letterSpacing: '1.5px', fontSize: '0.9rem' }}>
                            {cat}
                        </h5>
                        <div className="card border-0 shadow-sm overflow-hidden" style={{ borderRadius: '15px' }}>
                            <div className="card-body p-0">
                                <div className="list-group list-group-flush">
                                    {paramsDeEstaCat.map((param, index) => {
                                        const tipo = (param.tipo_dato || '').trim().toUpperCase();
                                        const valorActual = valores[param.codigo];

                                        return (
                                            <div key={param.id} className="list-group-item p-4 border-light">
                                                <div className="row align-items-center">
                                                    <div className="col-md-7">
                                                        <h6 className="font-weight-bold text-dark mb-1">{param.nombre}</h6>
                                                        <p className="text-muted small mb-0">{param.descripcion}</p>
                                                    </div>
                                                    <div className="col-md-5 d-flex justify-content-end">
                                                        {tipo === 'BOOLEAN' ? (
                                                            <div className="d-flex align-items-center">
                                                                <span className={`mr-3 small font-weight-bold ${valorActual ? 'text-success' : 'text-muted'}`}>
                                                                    {valorActual ? 'ACTIVADO' : 'DESACTIVADO'}
                                                                </span>
                                                                <div className="custom-control custom-switch custom-switch-lg">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="custom-control-input"
                                                                        id={param.codigo}
                                                                        checked={!!valorActual}
                                                                        onChange={(e) => handleInputChange(param.codigo, e.target.checked, 'BOOLEAN')}
                                                                    />
                                                                    <label className="custom-control-label" htmlFor={param.codigo}></label>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="input-group" style={{ maxWidth: '250px' }}>
                                                                <input
                                                                    type={tipo === 'NUMBER' ? 'number' : 'text'}
                                                                    className="form-control border-0 bg-light rounded-lg text-right font-weight-bold"
                                                                    style={{ fontSize: '0.95rem' }}
                                                                    value={valorActual !== undefined && valorActual !== null ? valorActual : ''}
                                                                    onChange={(e) => handleInputChange(param.codigo, e.target.value, tipo)}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>

        <style>{`
            /* Efecto Switch más Pro */
            .custom-switch.custom-switch-lg .custom-control-label::before {
                height: 1.5rem;
                width: 2.75rem;
                border-radius: 1rem;
            }
            .custom-switch.custom-switch-lg .custom-control-label::after {
                width: calc(1.5rem - 4px);
                height: calc(1.5rem - 4px);
                border-radius: 1rem;
            }
            .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
                transform: translateX(1.25rem);
            }
            
            /* Animación suave al pasar el mouse */
            .list-group-item {
                transition: background 0.2s;
            }
            .list-group-item:hover {
                background-color: #fcfcfc;
            }
            
            /* Quitar el borde feo azul de los inputs */
            .form-control:focus {
                box-shadow: none;
                background-color: #f2f2f2 !important;
            }
        `}</style>
    </div>
);
};

export default ConfiguracionParametros;